module.exports = "/* :host /deep/ lets shadowdom style child elements */\n:host /deep/ {\n  /**\r\n    * CSS Overrides for bug fixes\r\n    */\n  /**\r\n    * END CSS Overrides for bug fixes\r\n    */\n  /* Manage list custom styles */ }\n:host /deep/ .md-sort-item /deep/ .md-list-item-content {\n    padding: 0; }\n:host /deep/ .md-sort-icon {\n    font-size: 15px;\n    margin-right: 10px; }\n:host /deep/ .md-sort-header {\n    padding: 10px; }\n:host /deep/ .md-sort-header:hover {\n      background-color: #EEEEEE;\n      cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main